import { useState } from 'react';

export const useMenuToggle = (initStatus = false) => {
  const [isOpen, setIsOpen] = useState(initStatus);
  const closeMenu = () => setIsOpen(false);
  const openMenu = () => setIsOpen(true);
  return { isOpen, openMenu, closeMenu };
};
